var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0516 52.6667C36.0346 52.6668 36.0176 52.6668 36.0007 52.6668C26.7959 52.6668 19.334 45.2049 19.334 36.0002C19.334 26.7954 26.7959 19.3335 36.0007 19.3335C45.2054 19.3335 52.6673 26.7954 52.6673 36.0002C52.6673 36.035 52.6672 36.0698 52.667 36.1046V36.0001H49.334C49.3339 28.6363 43.3644 22.6668 36.0007 22.6668C28.6369 22.6668 22.6673 28.6364 22.6673 36.0002C22.6673 43.3639 28.6367 49.3333 36.0003 49.3335V52.6667H36.0516Z",
    fill: "#1BA136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.f82c92a3553addb47c6498c8a23db971.svg";
export { ForwardRef as ReactComponent };